<style lang="scss" scoped>
.card {
  height: 186px;
  margin-bottom: 25px;
  border-top: 7px solid #3055e8;
  color: #2d3953;
  box-sizing: border-box;
  padding: 30px;
  position: relative;
  .title {
    font-size: 20px;
    margin-bottom: 10px;
  }
  .text {
    font-size: 12px;
    line-height: 16px;
  }
  .footer {
    width: 100%;
    height: 60px;
    position: absolute;
    bottom: 0;
    left: 0;
    border-top: 1px solid #bdc7db;
    /deep/ .el-button {
      position: absolute;
      right: 22px;
      top: 50%;
      transform: translateY(-50%);
      min-width: 84px;
      padding: 8px 0;
    }
  }
}
.info {
  border-right: 1px solid #bdc7db;
  height: 100%;
  color: #525a65;
  padding-left: 20px;
  padding-top: 27px;
  .logo {
    width: 96px;
    height: 96px;
    border-radius: 50%;
    border: 1px solid #bdc7db;
    float: left;
    margin-right: 20px;
  }
  .account {
    padding-top: 30px;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 5px;
  }
  .type {
    font-size: 12px;
    height: 20px;
    line-height: 20px;
  }
}
.count {
  height: 100%;
  text-align: center;
  color: #525a65;
  .bar {
    text-align: left;
    border-bottom: 1px solid #bdc7db;
    padding: 15px 0 10px 24px;
    color: #525a65;
    font-size: 16px;
  }
  .value {
    padding-top: 20px;
    font-size: 38px;
    font-weight: bold;
    margin-bottom: 5px;
  }
  .label {
    font-size: 13px;
  }
}
.renzheng {
  display: inline-block;
  width: 14px;
  height: 14px;
  vertical-align: middle;
  background: url("data:image/svg+xml;charset=utf8, %3Csvg width='14' height='14' viewBox='0 0 14 14' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath d='M14 7.086A7.037 7.037 0 0 0 6.914 0C3.134 0 0 3.134 0 7.086 0 10.866 3.134 14 6.914 14 10.866 14 14 10.866 14 7.086z' id='a'/%3E%3C/defs%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg%3E%3Cuse fill='%23FEECB6' xlink:href='%23a'/%3E%3Cpath stroke='%23FF7200' d='M13.5 7.086A6.537 6.537 0 0 0 6.914.5C3.385.5.5 3.435.5 7.086.5 10.59 3.41 13.5 6.914 13.5c3.65 0 6.586-2.885 6.586-6.414z'/%3E%3C/g%3E%3Cpath d='M3.552 7.416c-.064-.069-.068-.192-.026-.251l.334-.474a.15.15 0 0 1 .21-.03l2.28 1.824a.194.194 0 0 0 .245-.01l5.672-4.932a.173.173 0 0 1 .242.015l.275.283c.066.067.063.18.007.237l-6.208 6.378c-.062.063-.164.057-.227-.01l-2.804-3.03z' fill='%23FF7200'/%3E%3C/g%3E%3C/svg%3E");
}
</style>

<template>
  <div>
    <el-card
      shadow="never"
      class="mb20"
      style="height:150px"
      :body-style="{padding: 0,height:'150px'}"
    >
      <el-row style="height:100%">
        <el-col :span="10" class="info">
          <div class="clearfix">
            <img :src="detail ? detail.headImg : ''" alt class="logo" />
            <div class="fl">
              <div class="account">{{detail ? detail.nickName : ''}}</div>
              <div class="type">
                服务号
                <span class="renzheng" v-show="detail.verifyTypeInfo === 0"></span>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="14" class="count">
          <div class="bar">昨日指标</div>
          <el-row>
            <el-col :span="10">
              <div class="value">{{user.cumulateUser || '0'}}</div>
              <div class="label">总用户数</div>
            </el-col>
            <el-col :span="7">
              <div class="value">{{user.subscribed || '0'}}</div>
              <div class="label">新关注</div>
            </el-col>
            <el-col :span="7">
              <div class="value">{{user.unsubscribed || '0'}}</div>
              <div class="label">取消关注</div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-card>
    <AlertTips />
    <el-row :gutter="30">
      <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
        <el-card shadow="never" class="card" :body-style="{padding: 0}">
          <div class="title">自动回复</div>
          <div class="text">通过编辑内容或关键词规则，快速进行自动回复设置。</div>
          <div class="footer">
            <router-link :to="{path: `/third/${id}/autoReply`}" append>
              <el-button type="primary">使用</el-button>
            </router-link>
          </div>
        </el-card>
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
        <el-card shadow="never" class="card" :body-style="{padding: 0}">
          <div class="title">自定义菜单</div>
          <div class="text">菜单项可按需设定，并可为其设置响应动作</div>
          <div class="footer">
            <router-link :to="{path: `/third/${id}/custom`}" append>
              <el-button type="primary">使用</el-button>
            </router-link>
          </div>
        </el-card>
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
        <el-card shadow="never" class="card" :body-style="{padding: 0}">
          <div class="title">公众号素材管理</div>
          <div class="text">同步管理公众号内所有素材，获取图文素材链接</div>
          <div class="footer">
            <router-link :to="{path: `/third/${id}/lib`}" append>
              <el-button type="primary">使用</el-button>
            </router-link>
          </div>
        </el-card>
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
        <el-card shadow="never" class="card" :body-style="{padding: 0}">
          <div class="title">渠道二维码</div>
          <div class="text">不同场景的渠道二维码，区分粉丝来源方便统计分析</div>
          <div class="footer">
            <router-link :to="{path:`/third/${id}/channel`}" append>
              <el-button type="primary">使用</el-button>
            </router-link>
          </div>
        </el-card>
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8" v-show="false">
        <el-card shadow="never" class="card" :body-style="{padding: 0}">
          <div class="title">微信支付收银台</div>
          <div class="text">生成微信收款码，自定义金额收款，自助收款</div>
          <div class="footer">
            <router-link :to="{path:`/third/${id}/pay`}" append>
              <el-button type="primary">使用</el-button>
            </router-link>
          </div>
        </el-card>
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
        <el-card shadow="never" class="card" :body-style="{padding: 0}">
          <div class="title">群发消息</div>
          <div class="text">对公众号粉丝群发，支持文字图片图文</div>
          <div class="footer">
            <router-link :to="{path:`/third/${id}/mass`}" append>
              <el-button type="primary">使用</el-button>
            </router-link>
          </div>
        </el-card>
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
        <el-card shadow="never" class="card" :body-style="{padding: 0}">
          <div class="title">标签管理</div>
          <div class="text">管理自定义标签</div>
          <div class="footer">
            <router-link :to="{path:`/third/${id}/tag`}" append>
              <el-button type="primary">使用</el-button>
            </router-link>
          </div>
        </el-card>
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8" v-show="false">
        <el-card shadow="never" class="card" :body-style="{padding: 0}">
          <div class="title">test</div>
          <div class="text">test</div>
          <div class="footer">
            <router-link :to="{path:`/third/${id}/autoReply`}" append>
              <el-button type="primary">使用</el-button>
            </router-link>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import AlertTips from '@/components/alertTips';
export default {
  components: {
    AlertTips,
  },
  computed: {},
  props: ['id'],
  data() {
    return {
      detail: {},
      user: {},
    };
  },
  async mounted() {
    let res = await this.$http.get(`/api/official-account/${this.id}`);
    this.detail = res;
    this.$store.commit('user', { name: res.nickName, head: res.headImg });
    let res2 = await this.$http.get(`/api/${this.id}/analyze/yesterday/users`);
    console.log(res2);
    this.user = res2;
  },
  methods: {},
};
</script>
